<div *ngIf="carDataOne" style="
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-bottom: 50px;
    padding-top: 70px;
    align-items: center;
    justify-content: center;
  " class="col-md-12">
  <mat-spinner></mat-spinner>
  <p class="color-des">Cargando datos del formulario</p>
</div>



<div class="auth-content1 card o-hidden" *ngIf="!carDataOne">
  <div _ngcontent-gox-c322="" class="pl-3 auth-right ng-tns-c322-0">
    <img _ngcontent-gox-c322="" src="https://ind.mipaginaeswow.com/wp-content/uploads/2019/11/Grupo-25.png" alt=""
      class="ng-tns-c322-0" />
  </div>
  <span class="p-4">Pasos: {{ Indice }}/6</span>
  <mat-horizontal-stepper #stepper (selectionChange)="onStepChange($event)">
    <mat-step state="edit">
      <ng-template matStepperIcon="edit">
        <mat-icon>remove</mat-icon>
      </ng-template>
      <ng-template matStepLabel>Identificación del cliente</ng-template>
      <form [formGroup]="firstFormGroup" *ngIf="dataOne">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div>
                <div>
                  <h1 class="lab-blue otro">Datos de persona jurídica</h1>
                </div>
                <div class="separator-breadcrumb border-top"></div>

                <div class="row">
                  <div class="col-lg-4" id="apellidos" cl>
                    <label for="apellidos" class="color-s">Razón social</label>
                    <div class="form-group">
                      <input disabled formControlName="razSoc" class="form-control" type="text" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="nombre" class="color-s">Administrador</label>
                    <div class="form-group">
                      <input formControlName="admin" class="form-control" type="text" />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label for="nombre" class="color-s">Partida registral N°</label>
                    <div class="form-group">
                      <input (keypress)="numberOnly($event)" formControlName="parReg" class="form-control"
                        type="text" />
                    </div>
                  </div>

                  <div class="col-lg-2">
                    <label for="tipo_documento" class="color-s">Tipo de documento
                    </label>
                    <select disabled formControlName="tipDoc" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="RUC EIRL">RUC EIRL</option>
                      <option value="RUC SRL">RUC SRL</option>
                      <option value="RUC SAC">RUC SAC</option>
                      <option value="RUC SAA">RUC SAA</option>
                      <option value="RUC SA">RUC SA</option>
                      <option value="RUC Otros">RUC Otros</option>
                    </select>
                  </div>

                  <div class="col-lg-2" id="otro_documento">
                    <label for="otro_documento" class="color-s">Número del documento</label>
                    <div class="form-group">
                      <input disabled (keypress)="numberOnly($event)" formControlName="numDoc" class="form-control"
                        type="text" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Registro de personas jurídicas
                    </label>
                    <select formControlName="regPerJur" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Por definir">Por definir</option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">País de constitución
                    </label>
                    <select formControlName="paisToCons" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Venezuela">Venezuela</option>
                    </select>
                  </div>
                  <div class="col-lg-9">
                    <label for="correo" class="color-s">Dirección domicilio</label>
                    <div class="form-group">
                      <input formControlName="dirDom" class="form-control" type="text" />
                    </div>
                  </div>

                  <!-- <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s"
                      >Estado Civil
                    </label>
                    <select formControlName="estCiv" class="form-control">
                      <option disabled value="null">Selecciona una opción</option>
                      <option value="0">Soltero</option>
                      <option value="1">Casado</option>
                      <option value="2">Conviviente</option>
                      <option value="3">Divorciado</option>
                      <option value="4">Viudo</option>
                    </select> 
                  </div>  -->

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Departamento
                    </label>
                    <select formControlName="depar" class="form-control" 
                      [(ngModel)]="departamento" (change)="onChangeDepartamentosSelect()">
                      <option disabled value="null" selected>
                        Selecciona una opción
                      </option>

                      <option *ngFor="let departamento of departamentos" [value]="departamento.departamento">
                        {{departamento.departamento }}</option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Provincia
                    </label>
                    <select formControlName="prov" class="form-control"
                      [(ngModel)]="provincia" (change)="onChangeProvinciaSelect()">
                      <option disabled value="null" selected>
                        Selecciona una opción
                      </option>
                      <option *ngFor="let provincia of provincias" [value]="provincia.provincia">
                        {{provincia.provincia }}</option>
                    </select>
                  </div>


     

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Distrito
                    </label>
                    <select formControlName="distri" class="form-control"   [(ngModel)]="distrito">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option *ngFor="let distrito of distritos" [value]="distrito.distrito">
                        {{distrito.distrito }}</option>s
                    </select>
                  </div>

                  <div class="col-lg-2 mt-2">
                    <label for="tipo_documento" class="color-s">País </label>
                    <select formControlName="pais" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Peru">Perú</option>
                    </select>
                  </div>

                  <div class="col-lg-2 mt-2" id="otro_documento">
                    <label for="otro_documento" class="color-s">Código postal</label>
                    <div class="form-group">
                      <input (keypress)="numberOnly($event)" formControlName="codPos" class="form-control"
                        type="text" />
                    </div>
                  </div>

                  <div class="col-lg-4 mt-2">
                    <label for="tipo_documento" class="color-s">Celular</label>
                    <div class="form-group">
                      <input maxlength="9" (keypress)="numberOnly($event)" formControlName="celu" class="form-control"
                        type="text" />
                    </div>
                  </div>

                  <div class="col-lg-4 mt-2">
                    <label for="tipo_documento" class="color-s">Teléfono fijo(opcional)</label>
                    <div class="form-group">
                      <input maxlength="7" (keypress)="numberOnly($event)" formControlName="telFijo"
                        class="form-control" type="text" />
                    </div>
                  </div>

                  <div class="col-lg-5 mt-2">
                    <label for="correo" class="color-s">Correo electronico corporativo</label>
                    <div class="form-group">
                      <input disabled formControlName="email" class="form-control" type="text" />
                    </div>
                  </div>
                  <div class="col-lg-4 mt-2">
                    <label for="tipo_documento" class="color-s">Pagina web(opcional)</label>
                    <div class="form-group">
                      <input formControlName="pagWeb" class="form-control" type="text" />
                    </div>
                  </div>
                  <div class="col-md-12 mt-4" align="right">
                    <div class="form-group col-md-3">
                      <button (click)="saveOneForm()" class="btn btn-rounded btn-blue btn-block">
                        Continuar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step *ngIf="apa3"  >


      <ng-template matStepLabel>Actividad del cliente</ng-template>
      <form [formGroup]="secondFormGroup" *ngIf="dataTwo">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div>
                <div class="row">
                  <div class="col-lg-3">
                    <label for="fecha_nacimiento" class="color-s">Fecha de inicio de actividades</label>
                    <div class="form-group">
                      <input formControlName="questone" class="form-control" type="date" />
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">CIUU</label>
                    <select formControlName="questtwo" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Por definir">Por definir</option>
                    </select>
                  </div>

                  <div class="col-lg-3" id="otro_documento">
                    <label for="otro_documento" class="color-s">País de desarrollo de actividad principal</label>
                    <select formControlName="questtree" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Por definir">Por definir</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">¿Es sujeto obligado a informar a la UIF-PERÚ?
                    </label>
                    <select  formControlName="questfour" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Sí">Sí</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">¿Designó a su oficial de cumplimiento?
                    </label>
                    <select formControlName="questfive" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Sí">Sí</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">¿Está vinculado a IND?</label>
                    <select formControlName="questsix" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Si">Si</option>
                      <option value="Trabajador o directivo de IND">
                        Trabajador o directivo de IND
                      </option>
                      <option value="Trabajador o directivo de empresas relacionadas con IND">
                        Trabajador o directivo de empresas relacionadas con IND
                      </option>
                      <option value="Pariente de trabajador o directivo de IND">
                        Pariente de trabajador o directivo de IND
                      </option>
                      <option value="Empresa vinculada a IND">
                        Empresa vinculada a IND
                      </option>

                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-3" id="otro_documento">
                    <label for="otro_documento" class="color-s">¿Es representante o funcionario de otra SAB?
                    </label>
                    <select  formControlName="questseven" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Sí">Sí</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">¿Es un inversionista institucional?
                    </label>
                    <select  formControlName="questeight" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Sí">Sí</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s"><br />¿Busca alternativas de financiamiento?
                    </label>
                    <select formControlName="questtwelve" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s"><br />Modalidad de envío de órdenes (únicamente para
                      inversiones)
                    </label>

                    <mat-select class="form-control" formControlName="questten" multiple>
                      <mat-option disabled value="null">
                        Selecciona una opción
                      </mat-option>
                      <mat-option *ngFor="let item of tipTwoList" [value]="item">{{ item }}</mat-option>
                    </mat-select>

                    <!-- <select formControlName="questten" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="0">
                        Teléfonica(con grabación de llamada)
                      </option>
                      <option value="Correo electrónico">
                        Correo electrónico
                      </option>
                      <option value="Acceso Web">Acceso Web</option>
                      <option value="Escrito">Escrito</option>
                      <option value="Fax">Fax</option>
                    </select> -->
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s"><br />Acceso a estado de cuenta e información de
                      operaciones
                    </label>

                    <select  formControlName="questeleven" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <!-- <option value="Físico">Físico</option> -->
                      <option value="Digital(Acceso Web y/o Correo electrónico)">
                        Digital(Acceso Web y/o Correo electrónico)
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s"><br />Tipos de operaciones a realizar
                    </label>

                    <mat-select class="form-control" formControlName="questnine" multiple>
                      <mat-option disabled value="null">
                        Selecciona una opción
                      </mat-option>
                      <mat-option *ngFor="let item of tipOpeList" [value]="item">{{ item }}</mat-option>
                    </mat-select>

                    <!-- <select formControlName="questnine" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Renta variable (acciones y/o etfs)">
                        Renta variable (acciones y/o etfs)
                      </option>
                      <option
                        value="Renta fija (papeles comerciales y/o bonos)"
                      >
                        Renta fija (papeles comerciales y/o bonos)
                      </option>
                      <option value="Facturas negociables">
                        Facturas negociables
                      </option>
                      <option value="Operacion de Reporte">
                        Operacion de Reporte
                      </option>
                      <option value="Derivados">Derivados</option>
                      <option value="Operacion de cambio de moneda">
                        Operacion de cambio de moneda
                      </option>
                    </select> -->
                  </div>

                  <div class="col-md-12 mt-4" align="right">
                    <div class="form-group col-md-3">
                      <button (click)="saveTwoForm()" class="btn btn-rounded btn-blue btn-block">
                        Continuar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>

    <!-- showStepOperacionesDelClienteJuridico -operacionesDelClienteJuridicoData -->
    <mat-step *ngIf="showStepOperacionesDelClienteJuridico">
      <ng-template matStepLabel>Operaciones del cliente </ng-template>
      <form [formGroup]="operacionesDelClienteFormGroup" *ngIf="operacionesDelClienteJuridicoData">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div>
                <div class="row">
                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Tipos de operaciones a realizar</label>

                    <mat-select class="form-control" formControlName="question_tipos_operacion_realizar" multiple>
                      <mat-option disabled value="null">
                        Selecciona una opción
                      </mat-option>
                      <mat-option *ngFor="let item of tipOpeList" [value]="item">{{ item }}</mat-option>
                    </mat-select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">¿Busca alternativas de financiamiento?
                    </label>
                    <select formControlName="question_alternativas_de_financiamiento" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Modalidad de envío de órdenes (únicamente para
                      inversiones)
                    </label>

                    <mat-select class="form-control" formControlName="question_modalidad_de_envio_de_ordenes" multiple>
                      <mat-option disabled value="null">
                        Selecciona una opción
                      </mat-option>
                      <mat-option *ngFor="let item of tipTwoList" [value]="item">{{ item }}</mat-option>
                    </mat-select>
                  </div>

                  <div class="col-lg-4 mt-2">
                    <label for="tipo_documento" class="color-s">Acceso a estado de cuenta e información de
                      operaciones</label>
                    <select formControlName="question_acceso_estado_de_cuenta_e_informacion_de_operaciones"
                      class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Digital(Acceso Web y/o Correo electrónico)">
                        Digital (acceso web y/o correo electrónico)
                      </option>
                    </select>
                  </div>

                  <div class="col-md-12 mt-4" align="right">
                    <div class="form-group col-md-3">
                      <button (click)="saveOperacionesDelCliente()" class="btn btn-rounded btn-blue btn-block">
                        Continuar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>



    <!-- Información patrimonial y origen de fondos -->

    <mat-step *ngIf="showStepInformacionPatrimonial">
      <ng-template matStepLabel>Información patrimonial y origen de fondos </ng-template>
      <form [formGroup]="informacionPatrimonialFormGroup" *ngIf="informacionPatrimonialData">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div>
                <div>
                  <h1 class="lab-blue otro">Información patrimonial</h1>
                </div>
                <div class="separator-breadcrumb border-top"></div>
                <div class="row">
                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Ingreso promedio mensual (S/)
                    </label>
                    <div class="form-group">
                      <input maxlength="9" (keypress)="numberOnly($event)"
                        formControlName="question_ingreso_promedio_mensual" class="form-control" type="text" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Información financiera del último ejercicio - fecha
                    </label>
                    <div class="form-group">
                      <input formControlName="question_financiera_ultimo_ejercicio" class="form-control" type="date" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Procedencia de fondos
                    </label>

                    <mat-select class="form-control" formControlName="question_procedencia_fondos" multiple>
                      <mat-option disabled value="null">
                        Selecciona una opción
                      </mat-option>
                      <mat-option *ngFor="let item of tipFourList" [value]="item">{{ item }}</mat-option>
                    </mat-select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">¿La persona jurídica y/o alguno de sus accionistas ha
                      sido investigado o procesado por la comisión de algún
                      delito relacionado a lavado de activos, financiamiento de
                      terrorismo, corrupción u otro delito conexo?
                    </label>
                    <select formControlName="question_usted_o_accionistas_investigado_por_delito" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </select>
                  </div>





                  <div class="col-md-12 mt-4" align="right">
                    <div class="form-group col-md-3">
                      <button (click)="saveInformacionPatrimonial()" class="btn btn-rounded btn-blue btn-block">
                        Continuar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>

    <!-- Vinculados al cliente -->
    <!-- showStepVinculadosAlCliente - vinculadosAlClienteData -->
    <mat-step *ngIf="showStepVinculadosAlCliente">
      <ng-template matStepLabel>Vinculados al cliente </ng-template>
      <form [formGroup]="treeFormGroup" *ngIf="vinculadosAlClienteData">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div>

                <div class="row">


                  <ng-template #modaleditAccionista let-modal>
                    <div class="modal-header">
                      <h4 class="modal-title" id="modal-title">Editar</h4>
                      <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
                        (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body row" *ngIf="datAcc">
                      <div class="w-50 p-4">
                        <div class="form-group">
                          <label for="picker1">Nombres/Razón social</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90"
                            [(ngModel)]="datAcc.nombre_o_razon_social" [ngModelOptions]="{ standalone: true }"
                            class="form-control" type="text" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">Apellidos</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90"
                            [(ngModel)]="datAcc.apellidos" [ngModelOptions]="{ standalone: true }" class="form-control"
                            type="text" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">Tipo de documento</label>

                          <select [(ngModel)]="datAcc.tipo_documento" [ngModelOptions]="{ standalone: true }"
                            class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Dni">Dni</option>
                            <option value="Pasaporte">Pasaporte</option>

                            <option value="Carnet Ext">Carnet Ext.</option>
                            <option value="Carnet de Ident">
                              Carnet de Ident.
                            </option>
                            <option value="Nit">Nit</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">N° Documento</label>

                          <input minlength="8" maxlength="15" (keypress)="numberOnly($event)"
                            [(ngModel)]="datAcc.nro_documento" [ngModelOptions]="{ standalone: true }"
                            class="form-control" type="text" />
                        </div>
                      </div>
                      <div class="w-50 p-4">
                        <div class="form-group">
                          <label for="picker1">Nacionalidad</label>

                          <select [(ngModel)]="datAcc.nacionalidad" [ngModelOptions]="{ standalone: true }"
                            class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Peruana">Peruana</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1"> País de residencia</label>

                          <select [(ngModel)]="datAcc.pais_residencia" [ngModelOptions]="{ standalone: true }"
                            class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Ecuador">Ecuador</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">Fecha de nacimiento</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90"
                            [(ngModel)]="datAcc.fecha_nacimiento" [ngModelOptions]="{ standalone: true }"
                            class="form-control" type="date" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">¿Es una persona expuesta políticamente o tiene
                            vinculación con un PEP?</label>

                          <select [(ngModel)]="
                              datAcc.expuesto_politicamente_o_pertenece_pep
                            " [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">Participación(%) </label>

                          <input (keypress)="numberOnly($event)" min="1" max="100" [(ngModel)]="datAcc.participacion"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="number" />
                        </div>
                      </div>

                      <div class="col-md-12 mt-4" align="right">
                        <div class="form-group col-md-3">
                          <button (click)="saveEditAcc()" class="btn btn-rounded btn-blue btn-block">
                            Agregar
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #modalAccionista let-modal>
                    <div class="modal-header">
                      <h4 class="modal-title" id="modal-title">Agregar</h4>
                      <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
                        (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body row">
                      <div class="w-50 w-sm-100 pr-4 pl-4">
                        <div class="form-group">
                          <label for="picker1">Nombres/Razón social</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90" [(ngModel)]="datoAcc1"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="text" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">Apellidos</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90" [(ngModel)]="datoAcc2"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="text" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">Tipo de documento</label>

                          <select [(ngModel)]="datoAcc3" [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Dni">Dni</option>
                            <option value="Pasaporte">Pasaporte</option>

                            <option value="Carnet Ext">Carnet Ext.</option>
                            <option value="Carnet de Ident">
                              Carnet de Ident.
                            </option>
                            <option value="Nit">Nit</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">N° Documento</label>

                          <input minlength="8" maxlength="15" (keypress)="numberOnly($event)" [(ngModel)]="datoAcc4"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="text" />
                        </div>
                      </div>
                      <div class="w-50 w-sm-100 pr-4 pl-4">
                        <div class="form-group">
                          <label for="picker1">Nacionalidad</label>

                          <select [(ngModel)]="datoAcc5" [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Peruana">Peruana</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1"> País de residencia</label>

                          <select [(ngModel)]="datoAcc6" [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Ecuador">Ecuador</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">Fecha de nacimiento</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90" [(ngModel)]="datoAcc7"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="date" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">¿Es una persona expuesta políticamente o tiene
                            vinculación con un PEP?</label>

                          <select [(ngModel)]="datoAcc8" [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="null">
                              Selecciona una opción
                            </option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">Participación(%) </label>

                          <input (keypress)="numberOnly($event)" min="1" max="100" [(ngModel)]="datoAcc9"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="number" />
                        </div>
                      </div>

                      <div class="col-md-12 mt-4" align="right">
                        <div class="form-group col-md-3">
                          <button (click)="guardarAccionista()" class="btn btn-rounded btn-blue btn-block">
                            Agregar
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>

                  <div class="row col-md-12">
                    <div>
                      <h1 class="lab-blue otro">
                        Información de vinculados al clientes
                      </h1>
                    </div>
                    <div class="separator-breadcrumb border-top"></div>

                    <table class="table table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">Nombres/razón social</th>
                          <th scope="col">Apellidos</th>
                          <th scope="col">Tipo de documento</th>
                          <th scope="col">N° Documento</th>
                          <th scope="col">Nacionalidad</th>
                          <th scope="col">País de residencia</th>
                          <th scope="col">Fecha de nacimiento</th>
                          <th scope="col">
                            ¿Es una persona expuesta políticamente o tiene
                            vinculación con un PEP?
                          </th>
                          <th scope="col">Participación(%)</th>
                          <th scope="col">Editar</th>
                          <th scope="col">Eliminar</th>
                        </tr>
                      </thead>
                      <tbody  >
                        <!-- *ngFor="let item of dataAccionista; index as i" -->
                        <tr  *ngFor="let item of dataAccionista; let i = index"  >
                          <td>{{ item.nombre_o_razon_social }}</td>
                          <td>{{ item.apellidos }}</td>
                          <td>{{ item.tipo_documento }}</td>
                          <td>{{ item.nro_documento }}</td>
                          <td>{{ item.nacionalidad }}</td>
                          <td>{{ item.pais_residencia }}</td>
                          <td>{{ item.fecha_nacimiento }}</td>
                          <td>
                            {{ item.expuesto_politicamente_o_pertenece_pep }}
                          </td>
                          <td>{{ item.participacion }}</td>
                          <td>
                            <button (click)="
                                openeditAccionista(modaleditAccionista, item, i)
                              " class="btn btn-rounded btn-blue btn-block">
                              Editar
                            </button>
                          </td>
                          <td>
                            <button (click)="deletAccionistas(i)" class="btn btn-rounded btn-blue btn-block">
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row" *ngIf="dataAccionista?.length <= 0 && !loadData">
                    <ng-container>
                      <div style="padding: 1.5rem; color: var(--text-secondary)">
                        <p style="color: black">
                          No hay accionistas ingresados...
                        </p>
                      </div>
                    </ng-container>
                  </div>
                  <div class="row mt-4" align="left">
                    <div class="form-group col-md-12">
                      <button (click)="openAccionistas(modalAccionista)" class="btn btn-rounded btn-blue btn-block">
                        Agregar accionistas
                      </button>
                    </div>
                  </div>
                  <div>
                    <h1 class="lab-blue otro">
                      Relación de personas jurídicas que de acuerdo a la
                      regulación de vinculación y grupo económico, califiquen
                      como vinculadas al cliente
                    </h1>
                  </div>
                  <div class="separator-breadcrumb border-top"></div>

                  <div class="row col-md-12">
                    <table class="table table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">Razon social</th>
                          <th scope="col">Tipo de documento</th>
                          <th scope="col">N° Documento</th>

                          <th scope="col">Tipo de vinculacion</th>
                          <th scope="col"></th>

                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of dataPersonaJur; let i = index">
                          <td>{{ item.razon_social }}</td>
                          <td>{{ item.tipo_documento }}</td>
                          <td>{{ item.nro_documento }}</td>
                          <td>{{ item.tipo_vinculacion }}</td>
                          <td>
                            <button (click)="openeditJuridico(dataJuridico, item, i)"
                              class="btn btn-rounded btn-blue btn-block">
                              Editar
                            </button>
                          </td>
                          <td>
                            <button (click)="deletJuridico(i)" class="btn btn-rounded btn-blue btn-block">
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row" *ngIf="dataPersonaJur?.length <= 0 && !loadData">
                      <ng-container>
                        <div style="padding: 1.5rem; color: var(--text-secondary)">
                          <p style="color: black">
                            No hay personas juridicas ingresadas...
                          </p>
                        </div>
                      </ng-container>
                    </div>
                    <div class="row mt-4" align="left">
                      <div class="form-group col-md-12">
                        <button (click)="openJuridico(modalJuridoc)" class="btn btn-rounded btn-blue btn-block">
                          Agregar personas jurídicas
                        </button>
                      </div>
                    </div>

                    <ng-template #dataJuridico let-modal>
                      <div class="modal-header">
                        <h4 class="modal-title" id="modal-title">Editar</h4>
                        <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
                          (click)="modal.dismiss('Cross click')">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body" *ngIf="daJuri">
                        <div class="form-group">
                          <label for="picker1">Razón social</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90"
                            [(ngModel)]="daJuri.razon_social" [ngModelOptions]="{ standalone: true }"
                            class="form-control" type="text" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">Tipo de documento</label>

                          <select [(ngModel)]="daJuri.tipo_documento" [ngModelOptions]="{ standalone: true }"
                            class="form-control">
                            <option disabled value="">
                              Selecciona una opción
                            </option>
                            <option value="RUC EIRL">RUC EIRL</option>
                            <option value="RUC SRL">RUC SRL</option>
                            <option value="RUC SAC">RUC SAC</option>
                            <option value="RUC SAA">RUC SAA</option>
                            <option value="RUC SA">RUC SA</option>
                            <option value="RUC Otros">RUC Otros</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">N° Documento</label>
                          <div class="form-group">
                            <input minlength="8" maxlength="15" (keypress)="numberOnly($event)"
                              [(ngModel)]="daJuri.nro_documento" [ngModelOptions]="{ standalone: true }"
                              class="form-control" type="text" />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="picker1">Tipo de vinculación</label>

                          <select [(ngModel)]="daJuri.tipo_vinculacion" [ngModelOptions]="{ standalone: true }"
                            class="form-control">
                            <option disabled value="">
                              Selecciona una opción
                            </option>
                            <option value="Empleado">Empleado</option>
                          </select>
                        </div>

                        <div class="col-md-12 mt-4" align="center">
                          <div class="form-group">
                            <button (click)="saveEditJuridico()" class="btn btn-rounded btn-blue btn-block">
                              Editar
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-template>

                    <ng-template #modalJuridoc let-modal>
                      <div class="modal-header">
                        <h4 class="modal-title" id="modal-title">Agregar</h4>
                        <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
                          (click)="modal.dismiss('Cross click')">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="form-group">
                          <label for="picker1">Razón social</label>

                          <input (keypress)="lettersOnly($event)" minlength="10" maxlength="90" [(ngModel)]="dato1"
                            [ngModelOptions]="{ standalone: true }" class="form-control" type="text" />
                        </div>

                        <div class="form-group">
                          <label for="picker1">Tipo de documento</label>

                          <select [(ngModel)]="dato2" [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="">
                              Selecciona una opción
                            </option>
                            <option value="RUC EIRL">RUC EIRL</option>
                            <option value="RUC SRL">RUC SRL</option>
                            <option value="RUC SAC">RUC SAC</option>
                            <option value="RUC SAA">RUC SAA</option>
                            <option value="RUC SA">RUC SA</option>
                            <option value="RUC Otros">RUC Otros</option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="picker1">N° Documento</label>
                          <div class="form-group">
                            <input minlength="8" maxlength="15" (keypress)="numberOnly($event)" [(ngModel)]="dato3"
                              [ngModelOptions]="{ standalone: true }" class="form-control" type="text" />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="picker1">Tipo de vinculación</label>

                          <select [(ngModel)]="dato4" [ngModelOptions]="{ standalone: true }" class="form-control">
                            <option disabled value="">
                              Selecciona una opción
                            </option>
                            <option value="Empleado">Empleado</option>
                          </select>
                        </div>

                        <div class="col-md-12 mt-4" align="center">
                          <div class="form-group">
                            <button (click)="guardarPersonJuridica()" class="btn btn-rounded btn-blue btn-block">
                              Agregar
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>

                  <div class="col-md-12 mt-4" align="right">
                    <div class="form-group col-md-3">
                      <button (click)="saveVinculadosAlCliente()" class="btn btn-rounded btn-blue btn-block">
                        Continuar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>

    <!-- showPersonasAutorizadas -  dataFour -->
    <mat-step *ngIf="showPersonasAutorizadas">
      <ng-template matStepLabel>Personas autorizadas
      </ng-template>
      <form [formGroup]="fourFormGroup" *ngIf="dataFour">
        <div class="row">
          <div class="col-md-12">
            <div class="p-2">
              <div>
                <div class="col-lg-4">
                  <label for="tipo_documento" class="color-s">¿Que vínculo tienes con la PJ?
                  </label>
                  <select formControlName="questone" class="form-control" (ngModelChange)="showIsProxy($event)">
                    <option disabled value="null">Selecciona una opción</option>
                    <option value="Representante legal/apoderado">
                      Representante legal/apoderado
                    </option>
                    <option value="Persona autorizada">
                      Persona autorizada
                    </option>
                    <option value="Persona de contacto">
                      Persona de contacto
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="dataFinal">
            <div class="p-4">
              <div>
                <div class="row">
                  <div class="col-lg-4" id="apellidos">
                    <label for="apellidos" class="color-s">Nombres</label>
                    <div class="form-group">
                      <input formControlName="questtwo" class="form-control" type="text" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="nombre" class="color-s">Apellidos</label>
                    <div class="form-group">
                      <input formControlName="questtree" class="form-control" type="text" />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label for="fecha_nacimiento" class="color-s">Fecha nacimiento</label>
                    <div class="form-group">
                      <input formControlName="questfour" class="form-control" type="date" />
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">Tipo de documento
                    </label>
                    <select formControlName="questfive" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Dni">Dni</option>
                      <option value="Pasaporte">Pasaporte</option>

                      <option value="Carnet Ext">Carnet Ext.</option>
                      <option value="Carnet Ident">Carnet Ident.</option>
                    </select>
                  </div>

                  <div class="col-lg-3" id="otro_documento">
                    <label for="otro_documento" class="color-s">Número del documento</label>
                    <div class="form-group">
                      <input (keypress)="numberOnly($event)" formControlName="questsix" class="form-control"
                        type="text" />
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">Nacionalidad</label>
                    <select formControlName="questseven" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Peruana">Peruana</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s">País de nacimiento</label>
                    <select formControlName="questeight" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Peru">Peru</option>
                    </select>
                  </div>
                  <div class="col-lg-9">
                    <label for="correo" class="color-s">Dirección domicilio</label>
                    <div class="form-group">
                      <input formControlName="questnine" class="form-control" type="text" />
                    </div>
                  </div>

                  <!-- <div class="col-lg-3">
                    <label for="tipo_documento" class="color-s"
                      >Estado Civil
                    </label>
                    <select formControlName="questten" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Soltero">Soltero</option>
                      <option value="Casado">Casado</option>
                      <option value="Conviviente">Conviviente</option>
                      <option value="Divorciado">Divorciado</option>
                      <option value="Viudo">Viudo</option>
                    </select>
                  </div> -->

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Departamento
                    </label>
                    <select formControlName="questeleven" class="form-control"
                      (change)="onChangeDepartamentosPersonaAutorizadaSelect()"
                      [(ngModel)]="departamentoPersonaAutorizada">
                      <option disabled value="null" selected>
                        Selecciona una opción
                      </option>

                      <option *ngFor="let departamento of departamentos" [value]="departamento.departamento">
                        {{departamento.departamento }}</option>
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Provincia
                    </label>
                    <select formControlName="questtwelve" class="form-control"
                      (change)="onChangeProvinciaPersonaAutorizadaSelect()" [(ngModel)]="provinciaPersonaAutorizada">
                      <option disabled value="null" selected>
                        Selecciona una opción
                      </option>
                      <option *ngFor="let provincia of provinciasPersonaAutorizada" [value]="provincia.provincia">
                        {{provincia.provincia }}</option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Distrito
                    </label>
                    <select formControlName="questthirteen" class="form-control"
                      [(ngModel)]="distritoPersonaAutorizada">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option *ngFor="let distrito of distritosPersonaAutorizada" [value]="distrito.distrito">
                        {{distrito.distrito}}</option>
                    </select>
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label for="tipo_documento" class="color-s">País </label>
                    <select formControlName="questfourteen" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Peru">Peru</option>
                    </select>
                  </div>

                  <div class="col-lg-3 mt-3" id="otro_documento">
                    <label for="otro_documento" class="color-s">Código postal</label>
                    <div class="form-group">
                      <input (keypress)="numberOnly($event)" formControlName="questfivteen" class="form-control"
                        type="text" />
                    </div>
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label for="tipo_documento" class="color-s">Celular</label>
                    <div class="form-group">
                      <input maxlength="9" (keypress)="numberOnly($event)" formControlName="questsixteen"
                        class="form-control" type="text" />
                    </div>
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label for="tipo_documento" class="color-s">Teléfono Fijo</label>
                    <div class="form-group">
                      <input maxlength="7" (keypress)="numberOnly($event)" formControlName="questseventeen"
                        class="form-control" type="text" />
                    </div>
                  </div>

                  <div class="col-lg-9">
                    <label for="correo" class="color-s">Correo</label>
                    <div class="form-group">
                      <input formControlName="questeighteen" class="form-control" type="text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="p-4">
              <div>
                <div class="row">

                  <div class="col-md-12" *ngIf="boxingIsProxy">
                    <div class=" row">
                      <div class="col-lg-2">
                        <label for="tipo_documento" class="color-s">Fecha del poder
                        </label>
                        <div class="form-group">
                          <input formControlName="questtwuelve" class="form-control" type="date" />
                        </div>
                      </div>

                      <div class="col-lg-2" id="otro_documento">
                        <label for="otro_documento" class="color-s">Partida registral N°</label>
                        <div class="form-group">
                          <input (keypress)="numberOnly($event)" formControlName="questtwuelveone" class="form-control"
                            type="text" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">¿Es una persona expuesta políticamente o tiene
                      vinculación con un PEP?
                    </label>
                    <select formControlName="questtwuelvetwo" class="form-control"
                      (ngModelChange)="showExposedPersonOptions($event)">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>

                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label for="tipo_documento" class="color-s">Registro de personas jurídicas de:
                    </label>
                    <select formControlName="questtwuelvetree" class="form-control">
                      <option disabled value="null">
                        Selecciona una opción
                      </option>
                      <option value="opcion 1">opcion 1</option>
                    </select>
                  </div>

                  <div class="col-md-12 mt-3" *ngIf="boxingExposedPersonOptions">
                    <div class="row">


                      <div class="col-lg-4">
                        <label for="correo" class="color-s">Nombres</label>
                        <div class="form-group">
                          <input formControlName="questtwuelvefour" class="form-control" type="text" />
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <label for="correo" class="color-s">Apellidos</label>
                        <div class="form-group">
                          <input formControlName="questtwuelvefive" class="form-control" type="text" />
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <label for="tipo_documento" class="color-s">Nombre de la institución
                        </label>
                        <div class="form-group">
                          <input formControlName="questtwuelvesix" class="form-control" type="text" />
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <label for="tipo_documento" class="color-s">Cargo </label>

                        <input formControlName="questtwuelveseven" class="form-control" type="text" />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 mt-4" align="right">
                    <div class="form-group col-md-3">
                      <button (click)="savePersonasAutorizadas()" class="btn btn-rounded btn-blue btn-block">
                        Continuar
                      </button>
                    </div>

                    <div class="form-group col-md-3">
                      <button (click)="abrirAnexo()" *ngIf="estAnexo" class="btn btn-rounded btn-blue btn-block">
                        Ver Anexos
                      </button>
                    </div>

                    
                    <div class="form-group col-md-3 "  >
                      <button  *ngIf="_Register.btnAccesoFirmaJuridico"  (click)="onClick()" class="btn btn-rounded btn-blue btn-block">
                         Acceder a la firma
                      </button>
                        
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>